import { useEffect, useMemo, useRef, useState } from "react";
import { usePresenceUtils } from "./PresenceElement";
export function usePresenceEventCallback(action) {
    var presenceElement = usePresenceUtils();
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(presenceElement === null || presenceElement === void 0 ? void 0 : presenceElement.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = presenceElement === null || presenceElement === void 0 ? void 0 : presenceElement.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            setData(data);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [presenceElement === null || presenceElement === void 0 ? void 0 : presenceElement.on, memoizedAction]);
    return data;
}
